/**
 * Shared Tailwind class groups for modal layout.
 * Used by Modal / ModalContent; import these when building one-off dialogs
 * so mobile behaviour stays consistent without duplicating magic values.
 */

/** Max height — leaves visible backdrop above/below on mobile. */
export const MODAL_PANEL_MAX_HEIGHT =
  'max-h-[min(70dvh,calc(100dvh-env(safe-area-inset-top,0px)-env(safe-area-inset-bottom,0px)-4rem))] sm:max-h-[min(85vh,900px)]';

/** Flex shell so nested scroll regions can shrink inside max-height panels. */
export const MODAL_PANEL_FLEX_SHELL = 'flex min-h-0 flex-col overflow-hidden';

/** Scrollable body when the panel uses default padding (simple modals). */
export const MODAL_PANEL_SCROLL_BODY =
  'min-h-0 flex-1 overflow-y-auto overscroll-contain touch-pan-y [-webkit-overflow-scrolling:touch]';

/** Fully rounded card on all breakpoints. */
export const MODAL_PANEL_RADIUS = 'rounded-xl';

/** Width is capped by overlay padding; never edge-to-edge. */
export const MODAL_PANEL_WIDTH = 'w-full mx-auto';

/** Responsive content padding with safe-area at the bottom on mobile. */
export const MODAL_PANEL_PADDING =
  'p-4 pb-[max(1rem,env(safe-area-inset-bottom,0px))] sm:p-6';

/** Overlay inset so the panel floats with visible backdrop on every side. */
export const MODAL_OVERLAY_INSET = 'p-4 sm:py-8';
